<nb-card class="card-box">
    <nb-card-header class="content-header">
        <span class="title">{{'user.teams' | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body">
        <app-unavailable-feature [image]="'assets/modals/unavailable-teamwork.png'"
                                 attention="{{ 'packets.function-is-not-included-in-your-plan' | translate }} {{'packets.professional' | translate }}."
                                 descriptionTitle="{{ 'packets.work-as-team' | translate }}"
                                 descriptionContent="{{ 'packets.teams-explanation' | translate }}"
                                 (cancelCallback)='cancel()'>
        </app-unavailable-feature>
    </nb-card-body>
</nb-card>
